// Definitions

(function() {

  if (typeof window.SITE === "undefined") {
    window.SITE = {};
  }

  SITE.portfolioFilters = function() {

    var portfolioForm = $('#form-portfolio-filter');

    if (portfolioForm.length) {
      // There can be only one filter active at a time.
      var stateFilter = portfolioForm.find('select[name="state"]');
      var cityFilter = portfolioForm.find('select[name="city"]');

      stateFilter.change(function () {
        cityFilter.find('option:selected').prop("selected", false);
        portfolioForm.submit();
      });

      cityFilter.change(function () {
        stateFilter.find('option:selected').prop("selected", false);
        portfolioForm.submit();
      });

    }
  }

  SITE.granteeFilters = function() {
    var granteeFilters = $('#form-grantee-filter');
    if (granteeFilters.length) {
      var sortFilter = granteeFilters.find('select[name="sort"]');
      var programFilter = granteeFilters.find('select[name="program"]');
      var siteFilter = granteeFilters.find('select[name="site"]')

      sortFilter.change(function() {
      //console.log(sortFilter.find('option:selected').prop("selected", false));
         granteeFilters.submit();
      });
      siteFilter.change(function() {
         granteeFilters.submit();
      })
      programFilter.change(function() {
        granteeFilters.submit()
      })

    }
  }

  SITE.resourceFilters = function() {
    var resourceFilter = $('#form-resource-filter');

    if (resourceFilter.length) {
      var sortFilter = resourceFilter.find('select[name="sort"]');
      var topicFilter = resourceFilter.find('select[name="topic"]');
      var typeFilter = resourceFilter.find('select[name="type"]');


      topicFilter.change(function() {
      //console.log(sortFilter.find('option:selected').prop("selected", false));
         resourceFilter.submit();
      });
      sortFilter.change(function() {
        resourceFilter.submit()
      })
      typeFilter.change(function() {
        resourceFilter.submit()
      })

    }
  }

})();


// Invocations

$(function () {
    SITE.portfolioFilters();
    SITE.granteeFilters();
    SITE.resourceFilters();
});
